<template>
  <div class="home">  
    <div class="b-row no-gutters">      
      <Sidebar @toggle="toggle" @applyFilter="applyRefinement" @reset="resetContentView"/>
      <main class="viewport" role="main">
        <Loader :visible="getRequestLoadStatus" />
        <Header />
        <Container :documents="getAllByLaws" :currentDocument="getDocument" v-if="!filterApplied"/>
        <div class="alert alert-info" v-if="filterApplied">
          You are looking at a portion of the by-law based on your filter selections. <router-link to="/?reset">Clear all filters</router-link> to view the complete by-law.
        </div>
        <FilterResult :list="filteredContent" v-if="filterApplied"/>         
      </main>   
    </div>
  </div>
</template>

<script>
import  "../../node_modules/bootstrap/scss/bootstrap.scss";
import Container from '@/components/ByLawContainer.vue';
import FilterResult from '@/components/FilterResult.vue';
import Loader from "@/components/Layout/Loader";
import Sidebar from '@/components/Layout/Sidebar.vue';
import Header from "@/components/Layout/HeaderLayout";
import Footer from "@/components/Layout/Footer";
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    Sidebar,
    Container,
    FilterResult,
    Loader
  }, 
  data(){
    return {
      showBar: false,
      filterApplied: false,
      filteredContent: null,
    };
  },
  watch: {    
    getSharePath: function (newvalue) {
      if(newvalue){       
        this.$router.push({path:`/show/${newvalue}`});   
      }
    },
    '$route.params.version': 'loadContent',
    '$route.params.definition': 'loadContent'
  },
  computed: {
    ...mapGetters("loader",["getRequestLoadStatus"]),
    ...mapGetters("viewer", ["getServiceStatus","getAllByLaws", "dataLoaded","getDocument","getSharePath"])
  },
  methods: {
    ...mapActions("viewer", [
      "fetchDocument",
      "fetchAllParts",
      "fetchSharePathForVersion",
      "fetchSharePathForDefinition",
      "fetchSharePathForTag",
      "fetchDefinitions"]),
    toggle: function(){
      this.showBar = !this.showBar;
      if(!this.showBar){
        this.filterApplied = false;
      }
    },
    resetContentView:function(){
      this.filterApplied = false;
    },
    applyRefinement: function(components){
      this.filterApplied = true;
      this.filteredContent = components;
    },
    loadContent: function(){       
      if(this.$route.name == "internalLink"){
        let version = this.$route.params.version;
         this.fetchSharePathForVersion(version);
        }
        else if(this.$route.name == "definitionLink"){
          let defn = this.$route.params.definition;
          this.fetchSharePathForDefinition(defn);
        } 
        else if(this.$route.name == "tagLink"){
          let tag = this.$route.params.tag;
          this.fetchSharePathForTag(tag);
        }
    }    
  },
  created: function() {
    this.loadContent();
    this.fetchDocument();
    this.fetchDefinitions();
    this.fetchAllParts();
  }
}
</script>
